import { common, mstCommon } from '@libs/domain';
import { Item } from '@ps-smart-cp/ppfw-client';

const segmentMstSettingFieldConfig = {
  displayName: Item.of(mstCommon.names.displayName, mstCommon.attributes.displayName),
  codeDigits: Item.of(mstCommon.names.codeDigits, mstCommon.attributes.codeDigits),
  isUsed: Item.of(common.names.isUsed, common.attributes.isUsed),
};

export { segmentMstSettingFieldConfig };
